var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"co form text muted",attrs:{"id":_vm.Id}},[_vm._v(_vm._s(_vm.Text))])])}
var staticRenderFns = []

export { render, staticRenderFns }